// filepath: c:\Users\fishi\Coding\AnnaKolb\src\data\artworks.js
const artworks = [
  {
    id: 1,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_4873.HEIC",
    title: "IMG_4873",
    category: "houses",
  },
  {
    id: 2,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_4872.HEIC",
    title: "IMG_4872",
    category: "houses",
  },
  {
    id: 3,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_4886.HEIC",
    title: "IMG_4886",
    category: "houses",
  },
  {
    id: 4,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_4852.HEIC",
    title: "IMG_4852",
    category: "houses",
  },
  {
    id: 5,
    src: process.env.PUBLIC_URL + "/imgs/houses/CB619201-43BD-4C58-8B53-75C9F7AB2244.JPG",
    title: "CB619201-43BD-4C58-8B53-75C9F7AB2244",
    category: "houses",
  },
  {
    id: 6,
    src: process.env.PUBLIC_URL + "/imgs/cars/car1.png",
    title: "car1",
    category: "cars",
  },
  {
    id: 7,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2787.PNG",
    title: "IMG_2787",
    category: "animals",
  },
  {
    id: 8,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2793.PNG",
    title: "IMG_2793",
    category: "animals",
  },
  {
    id: 9,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2776.PNG",
    title: "IMG_2776",
    category: "animals",
  },
  {
    id: 10,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2769.PNG",
    title: "IMG_2769",
    category: "animals",
  },
  {
    id: 11,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2784.PNG",
    title: "IMG_2784",
    category: "animals",
  },
  {
    id: 12,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2768.PNG",
    title: "IMG_2768",
    category: "animals",
  },
  {
    id: 13,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2786.PNG",
    title: "IMG_2786",
    category: "animals",
  },
  {
    id: 14,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2741.PNG",
    title: "IMG_2741",
    category: "animals",
  },
  {
    id: 15,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2729.PNG",
    title: "IMG_2729",
    category: "animals",
  },
  {
    id: 16,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2727.PNG",
    title: "IMG_2727",
    category: "animals",
  },
  {
    id: 17,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2790.PNG",
    title: "IMG_2790",
    category: "animals",
  },
  {
    id: 18,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2742.PNG",
    title: "IMG_2742",
    category: "animals",
  },
  {
    id: 19,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2730.PNG",
    title: "IMG_2730",
    category: "animals",
  },
  {
    id: 20,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2736.PNG",
    title: "IMG_2736",
    category: "animals",
  },
  {
    id: 21,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2792.PNG",
    title: "IMG_2792",
    category: "animals",
  },
  {
    id: 22,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2747.PNG",
    title: "IMG_2747",
    category: "animals",
  },
  {
    id: 23,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2770.PNG",
    title: "IMG_2770",
    category: "animals",
  },
  {
    id: 24,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2765.PNG",
    title: "IMG_2765",
    category: "animals",
  },
  {
    id: 25,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2731.PNG",
    title: "IMG_2731",
    category: "animals",
  },
  {
    id: 26,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2759.PNG",
    title: "IMG_2759",
    category: "animals",
  },
  {
    id: 27,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2740.PNG",
    title: "IMG_2740",
    category: "animals",
  },
  {
    id: 28,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2728.PNG",
    title: "IMG_2728",
    category: "animals",
  },
  {
    id: 29,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2758.PNG",
    title: "IMG_2758",
    category: "animals",
  },
  {
    id: 30,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2757.PNG",
    title: "IMG_2757",
    category: "animals",
  },
  {
    id: 31,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2771.PNG",
    title: "IMG_2771",
    category: "animals",
  },
  {
    id: 32,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2766.PNG",
    title: "IMG_2766",
    category: "animals",
  },
  {
    id: 33,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2785.PNG",
    title: "IMG_2785",
    category: "animals",
  },
  {
    id: 34,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2751.PNG",
    title: "IMG_2751",
    category: "animals",
  },
  {
    id: 35,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2763.PNG",
    title: "IMG_2763",
    category: "animals",
  },
  {
    id: 36,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2788.PNG",
    title: "IMG_2788",
    category: "animals",
  },
  {
    id: 37,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2767.PNG",
    title: "IMG_2767",
    category: "animals",
  },
  {
    id: 38,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2732.PNG",
    title: "IMG_2732",
    category: "animals",
  },
  {
    id: 39,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2739.PNG",
    title: "IMG_2739",
    category: "animals",
  },
  {
    id: 40,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2775.PNG",
    title: "IMG_2775",
    category: "animals",
  },
  {
    id: 41,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2733.PNG",
    title: "IMG_2733",
    category: "animals",
  },
  {
    id: 42,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2750.PNG",
    title: "IMG_2750",
    category: "animals",
  },
  {
    id: 43,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2791.PNG",
    title: "IMG_2791",
    category: "animals",
  },
  {
    id: 44,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2738.PNG",
    title: "IMG_2738",
    category: "animals",
  },
  {
    id: 45,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2737.PNG",
    title: "IMG_2737",
    category: "animals",
  },
  {
    id: 46,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2746.PNG",
    title: "IMG_2746",
    category: "animals",
  },
  {
    id: 47,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2772.PNG",
    title: "IMG_2772",
    category: "animals",
  },
  {
    id: 48,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2756.PNG",
    title: "IMG_2756",
    category: "animals",
  },
  {
    id: 49,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2762.PNG",
    title: "IMG_2762",
    category: "animals",
  },
  {
    id: 50,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2760.PNG",
    title: "IMG_2760",
    category: "animals",
  },
  {
    id: 51,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2748.PNG",
    title: "IMG_2748",
    category: "animals",
  },
  {
    id: 52,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2761.PNG",
    title: "IMG_2761",
    category: "animals",
  },
  {
    id: 53,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2789.PNG",
    title: "IMG_2789",
    category: "animals",
  },
  {
    id: 54,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2773.PNG",
    title: "IMG_2773",
    category: "animals",
  },
  {
    id: 55,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2774.PNG",
    title: "IMG_2774",
    category: "animals",
  },
  {
    id: 56,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2779.PNG",
    title: "IMG_2779",
    category: "animals",
  },
  {
    id: 57,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2797.PNG",
    title: "IMG_2797",
    category: "animals",
  },
  {
    id: 58,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2778.PNG",
    title: "IMG_2778",
    category: "animals",
  },
  {
    id: 59,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2796.PNG",
    title: "IMG_2796",
    category: "animals",
  },
  {
    id: 60,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2783.PNG",
    title: "IMG_2783",
    category: "animals",
  },
  {
    id: 61,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2780.PNG",
    title: "IMG_2780",
    category: "animals",
  },
  {
    id: 62,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2777.PNG",
    title: "IMG_2777",
    category: "animals",
  },
  {
    id: 63,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2795.PNG",
    title: "IMG_2795",
    category: "animals",
  },
  {
    id: 64,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2794.PNG",
    title: "IMG_2794",
    category: "animals",
  },
  {
    id: 65,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2782.PNG",
    title: "IMG_2782",
    category: "animals",
  },
  {
    id: 66,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2781.PNG",
    title: "IMG_2781",
    category: "animals",
  },
  {
    id: 67,
    src: process.env.PUBLIC_URL + "/imgs/animals/dog1.PNG",
    title: "dog1",
    category: "animals",
  },
  {
    id: 68,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_2827.PNG",
    title: "IMG_2827",
    category: "animals",
  },
  {
    id: 69,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2994.PNG",
    title: "IMG_2994",
    category: "cars",
  },
  {
    id: 70,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2993.PNG",
    title: "IMG_2993",
    category: "cars",
  },
  {
    id: 71,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2990.PNG",
    title: "IMG_2990",
    category: "cars",
  },
  {
    id: 72,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2992.PNG",
    title: "IMG_2992",
    category: "cars",
  },
  {
    id: 73,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2988.PNG",
    title: "IMG_2988",
    category: "cars",
  },
  {
    id: 74,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_3001.PNG",
    title: "IMG_3001",
    category: "cars",
  },
  {
    id: 75,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2991.PNG",
    title: "IMG_2991",
    category: "cars",
  },
  {
    id: 76,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2997.PNG",
    title: "IMG_2997",
    category: "cars",
  },
  {
    id: 77,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2998.PNG",
    title: "IMG_2998",
    category: "cars",
  },
  {
    id: 78,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_2999.PNG",
    title: "IMG_2999",
    category: "cars",
  },
  {
    id: 79,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_3013.PNG",
    title: "IMG_3013",
    category: "houses",
  },
  {
    id: 80,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_3009.PNG",
    title: "IMG_3009",
    category: "houses",
  },
  {
    id: 81,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_3006.PNG",
    title: "IMG_3006",
    category: "houses",
  },
  {
    id: 82,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_3005.PNG",
    title: "IMG_3005",
    category: "houses",
  },
  {
    id: 83,
    src: process.env.PUBLIC_URL + "/imgs/houses/Screenshot_2025-07-13_at_3.50.13_PM.png",
    title: "Screenshot 2025-07-13 at 3.50.13 PM",
    category: "houses",
  },
  {
    id: 84,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_4031.PNG",
    title: "IMG_4031",
    category: "animals",
  },
  {
    id: 85,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_4029.PNG",
    title: "IMG_4029",
    category: "animals",
  },
  {
    id: 86,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_4030.PNG",
    title: "IMG_4030",
    category: "animals",
  },
  {
    id: 87,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_4107.PNG",
    title: "IMG_4107",
    category: "animals",
  },
  {
    id: 88,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_4242.PNG",
    title: "IMG_4242",
    category: "animals",
  },
  {
    id: 89,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5343.PNG",
    title: "IMG_5343",
    category: "houses",
  },
  {
    id: 90,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5491.PNG",
    title: "IMG_5491",
    category: "animals",
  },
  {
    id: 91,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5498.PNG",
    title: "IMG_5498",
    category: "animals",
  },
  {
    id: 92,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5493.PNG",
    title: "IMG_5493",
    category: "animals",
  },
  {
    id: 93,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5499.PNG",
    title: "IMG_5499",
    category: "animals",
  },
  {
    id: 94,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5492.PNG",
    title: "IMG_5492",
    category: "animals",
  },
  {
    id: 95,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5497.PNG",
    title: "IMG_5497",
    category: "animals",
  },
  {
    id: 96,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5496.PNG",
    title: "IMG_5496",
    category: "animals",
  },
  {
    id: 97,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5494.PNG",
    title: "IMG_5494",
    category: "animals",
  },
  {
    id: 98,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5505_1tsPiZNkYZeFMYFWyjky-1YZo08RdMXM5.PNG",
    title: "IMG_5505",
    category: "cars",
  },
  {
    id: 99,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5502.PNG",
    title: "IMG_5502",
    category: "cars",
  },
  {
    id: 100,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5504.PNG",
    title: "IMG_5504",
    category: "cars",
  },
  {
    id: 101,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5506.PNG",
    title: "IMG_5506",
    category: "cars",
  },
  {
    id: 102,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5512.PNG",
    title: "IMG_5512",
    category: "cars",
  },
  {
    id: 103,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5510.PNG",
    title: "IMG_5510",
    category: "cars",
  },
  {
    id: 104,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5507.PNG",
    title: "IMG_5507",
    category: "cars",
  },
  {
    id: 105,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5503.PNG",
    title: "IMG_5503",
    category: "cars",
  },
  {
    id: 106,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5501.PNG",
    title: "IMG_5501",
    category: "cars",
  },
  {
    id: 107,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5505_1SSykYRwESJTDPzMlmKIkCT02UviGY6KC.PNG",
    title: "IMG_5505",
    category: "cars",
  },
  {
    id: 108,
    src: process.env.PUBLIC_URL + "/imgs/cars/IMG_5509.PNG",
    title: "IMG_5509",
    category: "cars",
  },
  {
    id: 109,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5513_1DGjz4b8gjaIJvSw1I9n9bCfzoLFE9Yid.PNG",
    title: "IMG_5513",
    category: "houses",
  },
  {
    id: 110,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5525.PNG",
    title: "IMG_5525",
    category: "houses",
  },
  {
    id: 111,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5514.PNG",
    title: "IMG_5514",
    category: "houses",
  },
  {
    id: 112,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5515.PNG",
    title: "IMG_5515",
    category: "houses",
  },
  {
    id: 113,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5528.PNG",
    title: "IMG_5528",
    category: "houses",
  },
  {
    id: 114,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5522.PNG",
    title: "IMG_5522",
    category: "houses",
  },
  {
    id: 115,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5517.PNG",
    title: "IMG_5517",
    category: "houses",
  },
  {
    id: 116,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5527.PNG",
    title: "IMG_5527",
    category: "houses",
  },
  {
    id: 117,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5526.PNG",
    title: "IMG_5526",
    category: "houses",
  },
  {
    id: 118,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5519.PNG",
    title: "IMG_5519",
    category: "houses",
  },
  {
    id: 119,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5516.PNG",
    title: "IMG_5516",
    category: "houses",
  },
  {
    id: 120,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5523.PNG",
    title: "IMG_5523",
    category: "houses",
  },
  {
    id: 121,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5518.PNG",
    title: "IMG_5518",
    category: "houses",
  },
  {
    id: 122,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5521.PNG",
    title: "IMG_5521",
    category: "houses",
  },
  {
    id: 123,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5524.PNG",
    title: "IMG_5524",
    category: "houses",
  },
  {
    id: 124,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5513_1EseEgqbbxjs-ESNeCq6NaImyNxVcBdr7.PNG",
    title: "IMG_5513",
    category: "houses",
  },
  {
    id: 125,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_5520.PNG",
    title: "IMG_5520",
    category: "houses",
  },
  {
    id: 126,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1WDn127gwnK7OwtJd52SJgyUgP7fnAhbM.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 127,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1XuA0fqkouzvMODOr1hmUjJZG4KE6AGks.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 128,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5912.PNG",
    title: "IMG_5912",
    category: "animals",
  },
  {
    id: 129,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5913.PNG",
    title: "IMG_5913",
    category: "animals",
  },
  {
    id: 130,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5910.PNG",
    title: "IMG_5910",
    category: "animals",
  },
  {
    id: 131,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_5911.PNG",
    title: "IMG_5911",
    category: "animals",
  },
  {
    id: 132,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1QPJgNymPW7OUvcWr0oP1ISED_14H_xjs.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 133,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1MGz0NdozQgZeUF6gnRQ5d00JvcGet_5n.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 134,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1P8FPYUR1Ey0gony629lfKl5Qwox1tf_R.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 135,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_6565.PNG",
    title: "IMG_6565",
    category: "animals",
  },
  {
    id: 136,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1EoA_HQsBITaiQrebCsb6VViz2T7Pd8_f.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 137,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1HD0X_q8t8tqUinkh4UOixdTCCiWou0tL.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 138,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1tmX94cepKR-DWcH9Tjylu4aFinSBvsJ4.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 139,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1BCuT7tWMagbWUO9zE-ThkSv7EAuhCAYw.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 140,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1R3jXwIwMGmN5e4LkQ_QHYJzXl0UtB0DG.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 141,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_17sLpnv1NenWxrObfOFqqWbIOnScvajMK.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 142,
    src: process.env.PUBLIC_URL + "/imgs/animals/IMG_6562.PNG",
    title: "IMG_6562",
    category: "animals",
  },
  {
    id: 143,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1y-WoAbE8YAFeRYCu8IqCfJ2g_UkQK3C2.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 144,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1x1lzBzEPb4apnCJiJeAv0S6fmb59T0kU.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 145,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1FClUsB4dZUlRarI2oOPa1pqTJ4veajDQ.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 146,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1-uqwYULCXoru6o_IvzEkFQhYhUjzKxOX.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 147,
    src: process.env.PUBLIC_URL + "/imgs/animals/Cute_Cat_1.jpeg",
    title: "Cute Cat 1",
    category: "animals",
  },
  {
    id: 148,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1Xy7pCmWzhbISGRvpr28c_Ovn_fyb0d3k.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 149,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1LDJTpz8IWokoS68D2-hF3M3C8_m7-Mc5.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 150,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_10CQ7fOdJBS7yr3CBP8erxZLGCFJQ0aC0.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 151,
    src: process.env.PUBLIC_URL + "/imgs/houses/Untitled_design_1KjSdELM6OycH5qpQa-p93ZlDPkAklQAH.png",
    title: "Untitled design",
    category: "houses",
  },
  {
    id: 152,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_7389.HEIC",
    title: "IMG_7389",
    category: "houses",
  },
  {
    id: 153,
    src: process.env.PUBLIC_URL + "/imgs/houses/Untitled_design_1_gCLxHCUstXUnnEsWuxYylcpiRr9bzeO.png",
    title: "Untitled design",
    category: "houses",
  },
  {
    id: 154,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_2511.HEIC",
    title: "IMG_2511",
    category: "houses",
  },
  {
    id: 155,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_7451.HEIC",
    title: "IMG_7451",
    category: "houses",
  },
  {
    id: 156,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_7452.HEIC",
    title: "IMG_7452",
    category: "houses",
  },
  {
    id: 157,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_7403.PNG",
    title: "IMG_7403",
    category: "houses",
  },
  {
    id: 158,
    src: process.env.PUBLIC_URL + "/imgs/houses/IMG_7404.PNG",
    title: "IMG_7404",
    category: "houses",
  },
  {
    id: 159,
    src: process.env.PUBLIC_URL + "/imgs/houses/80317285451__38AB0CD8-1027-45CE-99BE-541ECDAF84A9.HEIC",
    title: "80317285451__38AB0CD8-1027-45CE-99BE-541ECDAF84A9",
    category: "houses",
  },
  {
    id: 160,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_14aJyJyfx4_PltVzTPzaeTLTL_rLqUKuu.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 161,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_16eL6YI3NC8YcGqjIIo8uIUXDyk5Qeb1X.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 162,
    src: process.env.PUBLIC_URL + "/imgs/animals/Untitled_design_1ht5n8in6YsaCD7TIeAPsqsYfFFK2Pqqn.png",
    title: "Untitled design",
    category: "animals",
  },
  {
    id: 163,
    src: process.env.PUBLIC_URL + "/imgs/cars/valhalla.png",
    title: "valhalla",
    category: "cars",
  }];

export default artworks;